module.exports = __webpack_public_path__ + "static/media/forms.48c64773.svg";